import { WidgetConnectorNew } from './WidgetConnectorNew';
import WidgetConnectorContainerNew from './WidgetConnectorContainerNew';

export default WidgetConnectorContainerNew;
export { WidgetConnectorNew };
